import { render, staticRenderFns } from "./navbarAdminEstudiante.vue?vue&type=template&id=ebf2db1c"
import script from "./navbarAdminEstudiante.vue?vue&type=script&lang=js"
export * from "./navbarAdminEstudiante.vue?vue&type=script&lang=js"
import style0 from "./navbarAdminEstudiante.vue?vue&type=style&index=0&id=ebf2db1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports